import React, { Component } from "react";
import { FormControl } from "react-bootstrap";
import { observer } from "mobx-react";

class Select extends Component {
  handleOnChange(ev) {
    let { model, dataMember } = this.props;
    if (model && dataMember) {
      model[dataMember] = ev.target.value;
    }
  }

  render() {
    let { model, dataMember, readOnly, required } = this.props;

    let value = null;
    if (model && dataMember) {
      value = model[dataMember];
    }

    value = value || "";

    return (
      <FormControl componentClass="select" value={value || ""} readOnly={readOnly} onChange={this.handleOnChange.bind(this)} required={required}>
        {this.props.options}
      </FormControl>
    );
  }
}

export default observer(Select);



// WEBPACK FOOTER //
// ./src/Core/Components/Inputs/Select/index.js